/*
 * User-facing text lives in apps/<app>/src/i18n/es-CO.json (ADR 0009). This module
 * only provides the lookup so both apps behave the same way.
 */

export type Messages = Readonly<Record<string, string>>;
export type MessageParams = Readonly<Record<string, string | number>>;

export type Translator<M extends Messages> = (
  key: keyof M & string,
  params?: MessageParams,
) => string;

/**
 * Builds a `t()` function over a flat message file. Placeholders use `{name}`.
 * A missing parameter is left visible (`{name}`) so it is caught in review.
 */
export function createTranslator<M extends Messages>(messages: M): Translator<M> {
  return (key, params) => {
    const template = messages[key];
    if (template === undefined) {
      return key;
    }
    if (!params) {
      return template;
    }
    return template.replace(/\{(\w+)\}/g, (placeholder, name: string) => {
      const value = params[name];
      return value === undefined ? placeholder : String(value);
    });
  };
}
